import styles from '../../assets/styles/LandingPage/Subscription.module.scss'
import React from 'react'
import { MimaButton, MimaText, PageLoader } from '../../components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { amountFormatter } from '../../utils/utils';
import { businessStore } from '../../stores';
import { toJS } from 'mobx';

const Subscription = ({ loading }) => {
    const [subscription, setSubscription] = useState("MONTHLY");

    const navigate = useNavigate();

    const { subscriptionPlans } = businessStore

    return (
        <section className={styles.subscription} id="subscription">
            <MimaText variant="h2" mb={1}>
                Choose the best plan for your Business
            </MimaText>
            <MimaText variant="subtitle" mb={4}>
                Enjoy Unlimited access to all features for the first 2 months
            </MimaText>
            <div className={styles.subscription__nav}>
                <div
                    onClick={() => {
                        setSubscription("MONTHLY");
                    }}
                    className={`${subscription === "MONTHLY"
                        ? styles.subscription__nav__active
                        : styles.subscription__nav__inactive
                        }`}
                >
                    Monthly billing
                </div>
                <div
                    onClick={() => {
                        setSubscription("QUARTERLY");
                    }}
                    className={`${subscription === "QUARTERLY"
                        ? styles.subscription__nav__active
                        : styles.subscription__nav__inactive
                        }`}
                >
                    Quarterly billing
                </div>
                <div
                    onClick={() => {
                        setSubscription("BIANNUAL");
                    }}
                    className={`${subscription === "BIANNUAL"
                        ? styles.subscription__nav__active
                        : styles.subscription__nav__inactive
                        }`}
                >
                    Biannual billing
                </div>
                <div
                    onClick={() => {
                        setSubscription("ANNUAL");
                    }}
                    className={`${subscription === "ANNUAL"
                        ? styles.subscription__nav__active
                        : styles.subscription__nav__inactive
                        }`}
                >
                    Annual billing
                </div>
            </div>

            {loading ? <PageLoader title="while we load plans" /> : (
                <div className={styles.subscription__cardClass}>
                    {subscriptionPlans?.map(plan => (
                        <div className={plan.name === "Premium" ? styles.popular : ""} key={plan._id}>
                            {plan.name === "Premium" && <MimaText variant="smallBold" mb={1} align="center" color="var(--color-white)">POPULAR</MimaText>}

                            <div className={styles.subscription__cardClass_card}>
                                <MimaText variant="small" mb={1}>{plan.name} Plan</MimaText>
                                {subscription === "MONTHLY" && (
                                    <div className={styles.beside}>
                                        <MimaText variant="h3" mb={1}>
                                            {amountFormatter("NGN").format(plan.amount)}
                                        </MimaText>
                                        <MimaText>/ Month</MimaText>
                                    </div>
                                )}
                                {subscription === "QUARTERLY" && (
                                    <>
                                        <div className={styles.beside}>
                                            <MimaText variant="h3">{amountFormatter("NGN").format(plan.amount * 3 * (100 - plan.threeMonthsDiscountPer) / 100)}</MimaText>
                                            <MimaText> / Quarter</MimaText>
                                        </div>
                                        <div className={styles.savings}>Save {plan.threeMonthsDiscountPer}%</div>
                                    </>

                                )}
                                {subscription === "BIANNUAL" && (

                                    <>
                                        <div className={styles.beside}>
                                            <MimaText variant="h3">
                                                {amountFormatter("NGN").format(plan.amount * 6 * (100 - plan.sixMonthsDiscountPer) / 100)}
                                            </MimaText>
                                            <MimaText> / Biannual</MimaText>
                                        </div>
                                        <div className={styles.savings}>Save {plan.sixMonthsDiscountPer}%</div>
                                    </>
                                )}
                                {subscription === "ANNUAL" && (
                                    <>
                                        <div className={styles.beside}>
                                            <MimaText variant="h3">
                                                {amountFormatter("NGN").format(plan.amount * 12 * (100 - plan.oneYearDiscountPer) / 100)}
                                            </MimaText>
                                            <MimaText> / Year</MimaText>
                                        </div>
                                        <div className={styles.savings}>Save {plan.oneYearDiscountPer}%</div>
                                    </>
                                )}

                                {plan.name === "Basic" &&
                                    (<MimaText variant="small">
                                        For small sized businesses. Billed every {subscription === "MONTHLY" ? "month" : subscription === "QUARTERLY" ? "quarter" : subscription === "BIANNUAL" ? "six months" : "year"}. Cancel anytime.
                                    </MimaText>)
                                }

                                {plan.name === "Premium" &&
                                    (<MimaText variant="small">
                                        For small and medium sized businesses. Billed every {subscription === "MONTHLY" ? "month" : subscription === "QUARTERLY" ? "quarter" : subscription === "BIANNUAL" ? "six months" : "year"}. Cancel anytime.
                                    </MimaText>)
                                }

                                {plan.name === "Enterprise" &&
                                    (<MimaText variant="small">
                                        For medium and large scale businesses. Billed every {subscription === "MONTHLY" ? "month" : subscription === "QUARTERLY" ? "quarter" : subscription === "BIANNUAL" ? "six months" : "year"}. Cancel anytime.
                                    </MimaText>)
                                }

                                <div className={styles.line}></div>
                                <ul className="custom-list">
                                    {plan.coverage.map((covers, i) => (
                                        <li>{covers}</li>
                                    ))}
                                </ul>
                                <div className={styles.getStarted}>
                                    <MimaButton
                                        title="Get Started"
                                        width={34}
                                        mt={3}
                                        onClick={() => {
                                            navigate(constant.Routes.SignUp);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </section>
    )
}
export default Subscription;